import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createEOI } from '~/services/AgentHub/AgentService';

import { CreateEoiParams } from '~/types/services/agentHub';

export function useCreateEOI() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: CreateEoiParams) => {
      return await createEOI(params);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['eoi'] });
    },
  });
}
